import React, { Component } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Divider,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

class DynamicAccordion extends Component {
  constructor(props) {
    super(props);
    //console.log(props)
    this.state = {
      selectedActions: this.props.initial_permissions || {},
    };
  }

  handleCheckboxChange = (module, action) => {
    this.setState((prevState) => {
      const currentActions = prevState.selectedActions[module] || [];
      
      const isSelected = currentActions.includes(action);
  
      const updatedModuleActions = isSelected
        ? currentActions.filter((a) => a !== action)
        : [...currentActions, action];
  
      const updatedSelectedActions = {
        ...prevState.selectedActions,
        [module]: updatedModuleActions,
      };
  
      // Remove module if no actions are selected
      if (updatedModuleActions.length === 0) {
        delete updatedSelectedActions[module];
      }
  
      // 🔔 Emit to parent
      this.props.onChange?.(updatedSelectedActions);
  
      return { selectedActions: updatedSelectedActions };
    });
  };
  

  render() {
    const { modulesData = [] } = this.props;

    if (!modulesData.length) {
      return (
        <Typography variant="h6" style={{ textAlign: "center", marginTop: "20px" }}>
          No Data Available
        </Typography>
      );
    }

    return (
      <div style={{ width: "100%" }}>
        {modulesData.map((moduleItem) => {
          // ✅ Count checked actions for this module
          const checkedCount = Object.values(this.state.selectedActions[moduleItem.module] || {}).filter(Boolean).length;
       
          

          return (
            <Accordion key={moduleItem.module} sx={{ marginBottom: "12px" , textTransform:'capitalize'}}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">
                  {moduleItem.module} 
                  {/* ✅ Show checked count */}
                  {checkedCount > 0 && (
                    <Typography component="span" style={{ marginLeft: "8px", color: "#1976d2" }}>
                      ({checkedCount} selected)
                    </Typography>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
                {moduleItem.actions.map((action) => (
                  <FormControlLabel
                    key={action}
                    control={
                      <Checkbox
                        // checked={!!this.state.selectedActions[moduleItem.module]?.[action]}
                        checked={this.state.selectedActions[moduleItem.module]?.includes(action) || false}
                        onChange={() => this.handleCheckboxChange(moduleItem.module, action)}
                      />
                    }
                    label={action}
                  />
                ))}
              </AccordionDetails>
              <Divider />
            </Accordion>
          );
        })}
      </div>
    );
  }
}

export default DynamicAccordion;
